import { useEffect, useState } from 'react';

export type NavItem = 'home' | 'bongworks' | 'canvas' | 'detail' | 'tools';

/**
 * 侧边栏高亮：视图即高亮。
 * - 「Bong作品」独立页改造后，首页图像精选/视频精选内容全部归首页——home 视图
 *   恒亮「首页」，原先滚动到作品区切到「Bong精选」的滚动监听随之退役
 * - editor 视图没有对应侧边栏项，映射为「首页」
 */
export function useActiveSection(currentView: NavItem | 'editor') {
  const [activeSection, setActiveSection] = useState<NavItem>(
    currentView === 'editor' ? 'home' : currentView
  );

  useEffect(() => {
    setActiveSection(currentView === 'editor' ? 'home' : currentView);
  }, [currentView]);

  return activeSection;
}
